import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { ISapConnection } from '../models'

export class GetSapConnectionApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/general/sapConnection',
      requesterInfo,
    })
  }

  public async getSapConnection(): Promise<ISapConnection> {
    return await this.getAsync<ISapConnection>()
  }
}
